import React from "react";
import { Link } from "react-router-dom";
import { useGroupOrder } from "../../services/group-order/group-order.context";
import {
  budgetLabel,
  formatDelivery,
  perPersonHint,
} from "../../services/group-order/group-order.utils";
import "./group-order.css";

const money = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

export const GroupOrderBanner = () => {
  const ctx = useGroupOrder();
  const go = ctx?.groupOrder;
  if (!go) return null;
  const fmt = (n: number) => money.format(n);
  // Same headcount as the budget line, so changing it updates both together.
  const hint = perPersonHint({ ...go, headCount: ctx.budget.headCount }, fmt);
  const title =
    ctx.mode === "office"
      ? `${go.repFirstName || "Your rep"} is treating you${go.label ? ` · ${go.label}` : ""}`
      : `Admin order${go.label ? `: ${go.label}` : ""}`;

  return (
    <section className="group-order-banner" aria-label="Admin order">
      <div>
        <h2 className="group-order-banner__title">{title}</h2>
        <div>
          {go.street || "Address not set yet"} · {formatDelivery(go)} · Planned for up to{" "}
          {go.maxHeadCount} people
        </div>
        {ctx.mode === "office" && (
          <div className="group-order-banner__sub">
            {go.repFirstName || "Your rep"} pays tax, fees and tip at checkout.
          </div>
        )}
      </div>
      {ctx.budget.totalBudget > 0 && (
        <div
          className={`group-budget ${ctx.budget.isOver ? "group-budget--over" : ""}`}
          aria-live="polite">
          {budgetLabel(ctx.budget, fmt)}
          {hint && <div className="group-budget__hint">Budget {hint}</div>}
        </div>
      )}
      {ctx.groupOrder.catererSlug && !ctx.readOnly && (
        <Link className="group-order-banner__browse" to={`${ctx.listPath}?browse=1`}>
          Browse other caterers
        </Link>
      )}
    </section>
  );
};
